import { AppPath } from '@shared/routes/app-routing.const';
import { AppPathType } from '@shared/routes/app-routing-type';

export type Navigation = {
    title: string;
    route: AppPathType;
};

export const navigation: Navigation[] = [
    {
        title: $localize`Features`,
        route: AppPath.FEATURES,
    },
    {
        title: $localize`Pricing`,
        route: AppPath.PRICING,
    },
    {
        title: $localize`About us`,
        route: AppPath.ABOUT_US,
    },
    {
        title: $localize`Contact us`,
        route: AppPath.CONTACT_US,
    },
    // {
    //     title: 'Blog',
    //     route: AppPath.BLOG,
    // },
];
